// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CustomersSection_cardContainer__wTyjW","cardBox":"CustomersSection_cardBox__7UaUU"};